var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 24,
    viewBox: "0 0 92 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#003A70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.139.029h-5.47c-2.025 0-3.653.734-4.885 2.2-1.098 1.358-1.646 2.991-1.646 4.9v11.19h3.933V6.98c0-2.03.878-3.045 2.635-3.045h4.08v10.438h-3.971v3.945h7.867V2.799c0-1.847-.848-2.77-2.543-2.77M10.597 3.936H4.102v10.438h6.495V3.936zm4.043 14.382H2.529c-.89 0-1.513-.168-1.866-.504-.354-.337-.53-.981-.53-1.936V.028H11.95c1.792 0 2.689.9 2.689 2.697v15.593z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#003A70",
    d: "M17.427.029h3.97v9.109h-3.97zM38.508 18.318h-3.97V3.936h-6.421v14.382h-3.934V2.725c0-1.797.915-2.696 2.744-2.696h8.946c1.757 0 2.635.923 2.635 2.77v15.52zM41.295.029h3.97v9.109h-3.97zM48.051.028h4.025v18.29h-4.025zM54.863.028h4.025v18.29h-4.025zM74.26 18.318h-4.006V3.936h-8.58V.028h9.44c.866 0 1.607.27 2.223.808.615.538.924 1.284.924 2.238v15.244z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4438",
    d: "M83.814 21.116h7.868v2.795h-7.868z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Logo.8d9556be.svg";
export { ForwardRef as ReactComponent };